import React, { useEffect, useRef } from 'react'
import { useFindMenu, useTrans, useUtente } from '@next-nx/hooks'
import {
  WContainer,
  Breadcrumbs,
  MainTitle,
  MainDescription,
  WImage,
} from '@next-nx/shared-ui/atoms'
import { Page } from '@next-nx/shared-ui/organisms'
import styles from './FlotteAziendaliTemplate.module.sass'
import { Swiper, SwiperSlide } from 'swiper/react'
import IconTextCard from '../../molecules/IconTextCard/IconTextCard'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import { ArrowLeft, ArrowRight } from '@next-nx/shared-ui/icons'
import BoxLink from '../../molecules/BoxLink/BoxLink'
import { useRouter } from 'next/router'
SwiperCore.use([Navigation, Pagination])

interface Props {
  pagina?: any
}

const FlotteAziendaliTemplate = (props: Props) => {
  const { pagina = {} } = props
  const router = useRouter()
  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)

  const t = useTrans()
  const paginaFlotte = useFindMenu('pagina-flotte-aziendali')
  const descrizionePagina = useFindMenu('descrizione-pagina', paginaFlotte)
  const vantaggi = useFindMenu('vantaggi-list', paginaFlotte)
  const boxItem = useFindMenu('box-contattaci', paginaFlotte)
  const documentiNecessari = useFindMenu('documenti-necessari', paginaFlotte)
  const { utente } = useUtente()
  const toolbarPresente = utente && (utente.isStaff || utente.isImpersonate)

  function scrollToAnchor() {
    const { hash } = window.location

    if (hash) {
      const id = hash.replace('#', '')
      const querySelector = 'div[data-for="' + id + '"]'
      const element = document.querySelector(querySelector)

      if (element) {
        const offset = element?.offsetTop - (toolbarPresente ? 45 : 0) - 80
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        })
      }
    }
  }

  useEffect(() => {
    scrollToAnchor()
  }, [router.asPath])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
        {!!pagina.mainImage && (
          <div className={styles.headerImage}>
            <WImage
              src={pagina.mainImage}
              maxWidth={1110}
              maxHeight={280}
              layout={'intrinsic'}
              objectFit={'cover'}
            />
          </div>
        )}
      </WContainer>
      <WContainer>
        <div className={styles.content}>
          <MainDescription
            html={descrizionePagina?.descriptionHtml}
            className={styles.descrizione}
          />
          <div className={styles.col}>
            {!!boxItem && (
              <BoxLink item={boxItem} className={styles.box} ctaVariant={'secondary'} />
            )}
          </div>
        </div>
        {vantaggi?.children?.edges?.length > 0 && (
          <div className={styles.serviziContent}>
            <div className={styles.serviziTitle} data-for="vantaggisection">
              {vantaggi?.name}
            </div>
            <div className={styles.slider}>
              <button
                role="button"
                id="categorie-section-prev"
                ref={navigationPrevRef}
                className={`${styles.nav} ${styles['nav--prev']}`}
              >
                <ArrowLeft />
              </button>
              <button
                role="button"
                id="categorie-section-next"
                ref={navigationNextRef}
                className={`${styles.nav} ${styles['nav--next']}`}
              >
                <ArrowRight />
              </button>
              <Swiper
                spaceBetween={30}
                watchOverflow
                slidesPerView={1.3}
                pagination={{ clickable: true }}
                centerInsufficientSlides
                navigation={{
                  prevEl: '#categorie-section-prev',
                  nextEl: '#categorie-section-next',
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 1.6,
                  },
                  768: {
                    slidesPerView: 2.3,
                  },
                  992: {
                    slidesPerView: 3,
                  },
                }}
              >
                {vantaggi?.children?.edges?.map((x, index) => (
                  <SwiperSlide key={index}>
                    <div className={styles.item}>
                      <IconTextCard item={x?.node} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
        {!!documentiNecessari && (
          <div className={styles.documentiContainer}>
            <div className={styles.documentiTitle}>{documentiNecessari.name}</div>
            <div className={styles.documentiDescription}>
              <MainDescription
                html={documentiNecessari.descriptionHtml}
                className={styles.descrizione}
              />
            </div>
          </div>
        )}
      </WContainer>
    </Page>
  )
}

export default FlotteAziendaliTemplate
